import ScoreByDeviceTagChart from './ScoreByDeviceTagChart';
export default ScoreByDeviceTagChart;



// WEBPACK FOOTER //
// ./src/components/ScoreByDeviceTagChart/index.js